import HttpClientToken from '../../services/HttpClientToken';
import HttpClientApiKey from '../../services/HttpClientApiKey';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';

import { AxiosError } from 'axios';

import { ObtenerAudienciasParams, SolicitudesProps, SolicitudProps } from '../../interfaces/comun/SolicitudInterface';

import { AgendaDetalle, AgendaLiberadaResponse, AsignarSalaAutomaticaParams, AsignarSalaAutomaticaResponse, AudienciaProps, BuscarAgendaSalasFecha, CancelarEventoParams, FinalizarAsignacionSalaParams, GuardarAgendaProps, ObtenerAudienciasPantallaResponse, RestablecerLiberarAgendaParams, RestblecerLiberarAgendasParams, SeleccionarSalaParams } from '../../interfaces/comun/AgendaInterface';

export const GuardarAgenda = (params: GuardarAgendaProps) => {

    return new Promise<AgendaDetalle>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClientToken.post('/Api/Agenda/GuardarAgenda', params, token)
            .then(({ data }: { data: AgendaDetalle }) => {
                resolve(data);
            })
            .catch( ( error: AxiosError ) => {
                resolve({ 
                    success: false,
                    message: error.message,
                    idAgenda: 0, 
                    duracion: 0, 
                    idEstatus: 0, 
                    idJuez: 0, 
                    juez : '', 
                    numeroExpediente : '', 
                    solicitante: '', 
                    tipoAudiencia: '',
                    fechaInicio: '',
                    fechaFin: '',
                    idSecretario: 0,
                    secretario: '',
                });
            });
        }

    });

}

export const ObtenerAgenda = () => {

    return new Promise<AudienciaProps[]>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClientToken.get('/Api/Agenda/ObtenerAgenda', token)
            .then(({ data }: { data: AudienciaProps[] }) => {
                resolve(data);
            })
            .catch(() => {
                resolve([]);
            });
        }

    });

}

export const ObtenerSolicitudes = () => {

    return new Promise<SolicitudProps[]>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClientToken.get('/Api/Agenda/ObtenerSolicitudes', token)
            .then(({ data }: { data: SolicitudProps[] }) => {
                resolve(data);
            })
            .catch(() => {
                resolve([]);
            });
        }

    });

}

export const ObtenerAudiencias = ( params: ObtenerAudienciasParams ) => {

    return new Promise<AudienciaProps[]>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClientToken.post('/Api/Agenda/ObtenerAudiencias', params, token)
            .then(({ data }: { data: AudienciaProps[] }) => {
                resolve( data );
            })
            .catch(() => {
                resolve( [] );
            });
        }

    });

}

export const CancelarAgenda = (params: CancelarEventoParams) => {

    return new Promise<HttpResponse>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClientToken.post('/Api/Agenda/CancelarAgenda', params, token)
            .then(({ data }: { data: HttpResponse }) => {
                resolve(data);
            })
            .catch( ( error: AxiosError ) => {
                resolve({ message: error.message, success: false });
            });
        }

    });

}

export const RestablecerAgenda = (params: RestablecerLiberarAgendaParams) => {

    return new Promise<HttpResponse>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClientToken.post('/Api/Agenda/RestablecerAgenda', params, token)
            .then(({ data }: { data: HttpResponse }) => {
                resolve(data);
            })
             .catch( ( error: AxiosError ) => {
                resolve({ message: error.message, success: false });
            });
        }

    });

}

export const LiberarAudiencia = (params: RestablecerLiberarAgendaParams) => {

    return new Promise<HttpResponse>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClientToken.post('/Api/Agenda/LiberarAudiencia', params, token)
            .then(({ data }: { data: HttpResponse }) => {
                resolve(data);
            })
             .catch( ( error: AxiosError ) => {
                resolve({ message: error.message, success: false });
            });
        }

    });

}

export const ObtenerConteoSolicitudes = () => {

    return new Promise<SolicitudesProps[]>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClientToken.get('/Api/Agenda/ObtenerConteoSolicitudes', token)
            .then(({ data }: { data: SolicitudesProps[] }) => {
                resolve(data);
            })
            .catch(() => {
                resolve([]);
            });
        }

    });

}

export const ObtenerAgendaSala = (param: BuscarAgendaSalasFecha) => {

    return new Promise<AgendaLiberadaResponse>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClientToken.post('/Api/Agenda/ObtenerAgendaSala', param , token)
            .then(({ data }: { data: AgendaLiberadaResponse }) => {
                resolve(data);
            })
            .catch(() => {
                resolve({ agenda: [], juezArray: [] });
            });
        }

    });

}

export const AsignarSala = (param: SeleccionarSalaParams) => {

    return new Promise<HttpResponse>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClientToken.post('/Api/Agenda/AsignarSala', param , token)
            .then(({ data }: { data: HttpResponse }) => {
                resolve(data);
            })
            .catch( ( error: AxiosError ) => {
                resolve({ message: error.message, success: false });
            });
        }

    });

}

export const FinalizarAsignacionSala = ( param: FinalizarAsignacionSalaParams ) => {

    return new Promise<HttpResponse>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClientToken.post('/Api/Agenda/FinalizarAsignacionSala', param , token)
            .then(({ data }: { data: HttpResponse }) => {
                resolve(data);
            })
            .catch( ( error: AxiosError ) => {
                resolve({ message: error.message, success: false });
            });
        }

    });

}

export const AsignarSalaAutomatica = ( param: AsignarSalaAutomaticaParams ) => {

    return new Promise<AsignarSalaAutomaticaResponse>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClientToken.post('/Api/Agenda/AsignarSalaAutomatica', param , token)
            .then(({ data }: { data: AsignarSalaAutomaticaResponse }) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve({ success: false, message: error.message, agenda: [], });
            });
        }

    });

}

export const RestablecerLiberarAgendas = ( param: RestblecerLiberarAgendasParams ) => {

    return new Promise<HttpResponse>((resolve, eject) => {

        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClientToken.post('/Api/Agenda/RestablecerLiberarAgendas', param , token)
            .then(({ data }: { data: HttpResponse }) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve({ success: false, message: error.message, });
            });
        }

    });

}

export const ObtenerAudienciasPantalla = ( id: number ) => {

    return new Promise<ObtenerAudienciasPantallaResponse>((resolve, eject) => {

        HttpClientApiKey.get(`/Api/Agenda/ObtenerAudienciasPantalla/${ id }`)
        .then(({ data }: { data: ObtenerAudienciasPantallaResponse }) => {
            resolve( data );
        })
        .catch( ( error: AxiosError ) => {
            resolve({ 
                success:    false, 
                message:    error.message, 
                autoridad:  '',
                audiencias: [],
            });
        });        

    });

}

